import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../services/authService';
import { logError } from '../utils/errorLogger';

const Login = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      logError('Login', 'handleLogin', err);
      // No need to show error UI here as MSAL handles the error display
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default'
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to Pulse Operation Portal
      </Typography>
      
      <Box sx={{ mb: 4, mt: 2 }}>
        <img 
          src="/images/pbilogo.jpg" 
          alt="Pulse Business Intelligence Logo"
          style={{
            maxWidth: '300px',
            height: 'auto',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}
        />
      </Box>
      
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogin}
        size="large"
      >
        Sign in with Microsoft
      </Button>
    </Box>
  );
};

export default Login; 